(function () {
    "use strict";



    Controllers.CoronaChooseTemplateController = class CoronaChooseTemplateController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor(
            $scope,
            $injector,
            $modalInstance,
            AppStates,
            modalParams,
            CompaniesManager,
            $timeout,
            AnalyticsService
        ) {

            super($scope, $injector);
            this.__objectType = 'CoronaChooseTemplateController';

            this.$modalInstance = $modalInstance;
            this.AppStates = AppStates;
            this.$timeout = $timeout;
            this.AnalyticsService = AnalyticsService;
            this.modalParams = modalParams;
            this.CompaniesManager = CompaniesManager;

            this.company = this.CompaniesManager.getCurrCompany();
            this.currProject = this.modalParams.project;
            this.projectId = this.currProject._id;
            this.workspaceId = this.currProject.workspaces[0]._id;


            this.filteredtemplates = this._filteredVendorEmails();
        }

        _filteredVendorEmails() {
            const keywords = [
                'corona',
                'virus',
                'covid'
            ];

            const filteredTemplates = this.company.vendor_emails.filter(vendorEmail => keywords.some(keyword => vendorEmail.title && vendorEmail.title.toLowerCase().includes(keyword)));

            return filteredTemplates.length > 0 ? filteredTemplates : this.company.vendor_emails;
        }

        composeEmailWithTemplate(templateId) {

            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.corona_action, {templateId: templateId, type: 'template', source:  'compose email'});

            this.goToState(this.AppStates.root_core_navigation_event_workspace_feed, {event_id: this.projectId, workspace_id: this.workspaceId, template_id: templateId});
            this.$timeout(() => {
                this.close();
            }, 2000);
        }

        close() {
            this.$modalInstance.close();
        }
    }


}());
